import React, { useState } from 'react';
import movieData from '../assets/data.json';
import ModalComponent from '../components/ModalComponent.jsx';
import { Button } from 'reactstrap';
export default function MoviesList() {
  const [modal, setModal] = useState(false);
  const [movie, setMovie] = useState('');
  const toggle = () => setModal(!modal);
  const getTrailer = async item => {
    let result = await fetch(
      `http://api.themoviedb.org/3/movie/${item.id}/videos?api_key=b821b0506b4f9020cc6ac49377f48963`
    );
    let resultJson = await result.json();
    setMovie(resultJson.results[0]);
    toggle();
  };
  const MovieItem = ({ item }) => {
    return (
      <div className="movie-it">
        <div className="card" style={{ backgroundColor: '#050A1A' }}>
          <div className="movies-img">
            <img
              src={
                item.poster_path
                  ? `https://image.tmdb.org/t/p/w600_and_h900_bestv2${item.poster_path}`
                  : ''
              }
              className="card-img-top"
              alt={item.id}
            />
          </div>
          <div className="movies-inner">
            <Button
              className="mb-2"
              color="secondary"
              onClick={() => getTrailer(item)}
            >
              Trailer
            </Button>
            <a
              href={item.driveFolder}
              className="btn btn-primary"
              style={{
                backgroundColor: '#cf2923',
                borderColor: '#cf2923',
                color: '#FFF'
              }}
              target="_blank"
              rel="noopener noreferrer"
            >
              Xem phim
            </a>
          </div>
          <div className="title-in">
            <h6>
              <a
                href={item.driveFolder}
                target="_blank"
                rel="noopener noreferrer"
              >
                {item.title || ''}
              </a>
            </h6>
            <p>
              <i className="fas fa-star movie-star"></i>
              <span>{item.vote_average || ''}</span> /10
            </p>
          </div>
        </div>
      </div>
    );
  };
  return (
    <div className="container">
      <div className="row">
        <div className="col-12 text-center my-3">
          <h3>Danh sách phim</h3>
        </div>
        <div className="col-12 movies__list my-4">
          {movieData.map((item, index) => (
            <MovieItem key={index} item={item} />
          ))}
        </div>
      </div>
      <ModalComponent toggle={toggle} modal={modal} movie={movie} />
    </div>
  );
}
